import React from 'react';
import * as PropTypes from 'prop-types';
import { ElementWrapper, TitleText, RightIcon, LeftIcon } from './elements';

function SeH004B(props) {
  return (
    <ElementWrapper className={props.className}>
      <TitleText>{props.title}</TitleText>
      {props.leftIcon && (
        <LeftIcon icon={props.leftIcon} onClick={props.onLeftIconClick} />
      )}
      {props.rightIcon && (
        <RightIcon icon={props.rightIcon} onClick={props.onRightIconClick} />
      )}
    </ElementWrapper>
  );
}

SeH004B.propTypes = {
  className: PropTypes.string,
  onLeftIconClick: PropTypes.func,
  onRightIconClick: PropTypes.func,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  title: PropTypes.string,
};

export default SeH004B;
